import reverse from 'django-reverse';
import axios from '__js__/axios';
import { URLS } from './URLS';

export const checkMapInterconnection = async () =>
	await axios.post(reverse(URLS.CHECK_MAP_INTERCONNECT));
